/**
 * A percentage as the report email and the dashboard print it: one decimal
 * where there is one ("75.5"), none where there isn't ("100"). Older snapshots
 * stored whole percents and read the same as before.
 */
export const percentText = (rate: number): string =>
  String(Math.round(rate * 10) / 10);
